<template>
  <div class="register-box">
    <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.0.13/css/all.css" />
    <div class="register-logo">
      <a href="#">
        <b class="text-warning">FX</b>hanuman
      </a>
    </div>

    <div class="card">
      <div class="card-body register-card-body">
        <p class="login-box-msg">Register</p>

        <form @submit.prevent="onSubmit()">
          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="email"
              v-validate="'required|email'"
              v-model.trim="form.email"
              :class="{ 'is-invalid': errors.has('email') }"
              placeholder="Email"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-envelope"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('email') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control"
              name="password"
              v-validate="'required|min:6'"
              v-model.trim="form.password"
              ref="password"
              :class="{ 'is-invalid': errors.has('password') }"
              placeholder="Password"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('password') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="password"
              class="form-control"
              name="password_confirmation"
              v-validate="'required|confirmed:password'"
              :class="{ 'is-invalid': errors.has('password_confirmation') }"
              data-vv-as="password"
              placeholder="Confirm Password"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-lock"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('password_confirmation') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="firstName"
              v-validate="'required'"
              v-model.trim="form.firstName"
              :class="{ 'is-invalid': errors.has('firstName') }"
              placeholder="ชื่อ (ภาษาอังกฤษ)"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('firstName') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="lastName"
              v-validate="'required'"
              v-model.trim="form.lastName"
              :class="{ 'is-invalid': errors.has('lastName') }"
              placeholder="นามสกุล (ภาษาอังกฤษ)"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-user"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('lastName') }}</span>
          </div>

          <!-- select gender -->
          <div class="form-group">
            <select
              class="form-control"
              name="gender"
              v-validate="'required'"
              v-model.trim="form.gender"
              :class="{ 'is-invalid': errors.has('gender') }"
            >
              <option value selected disabled hidden>เพศ</option>
              <option value="male">ชาย</option>
              <option value="female">หญิง</option>
            </select>
            <span class="invalid-feedback">{{ errors.first('gender') }}</span>
          </div>

          <!-- select province-->
          <!-- <Province></Province> -->
          <div class="form-group">
            <select
              class="form-control"
              id="province"
              name="province"
              v-validate="'required'"
              v-model.trim="form.province"
              :class="{ 'is-invalid': errors.has('province') }"
            >
              <option value selected disabled hidden>จังหวัด</option>
              <option>กระบี่</option>
              <option>กรุงเทพฯ</option>
              <option>กาญจนบุรี</option>
              <option>กาฬสินธุ์</option>
              <option>กำแพงเพชร</option>
              <option>ขอนแก่น</option>
              <option>จันทบุรี</option>
              <option>ฉะเชิงเทรา</option>
              <option>ชลบุรี</option>
              <option>ชัยนาท</option>
              <option>ชัยภูมิ</option>
              <option>ชุมพร</option>
              <option>เชียงราย</option>
              <option>เชียงใหม่</option>
              <option>ตรัง</option>
              <option>ตราด</option>
              <option>ตาก</option>
              <option>นครนายก</option>
              <option>นครปฐม</option>
              <option>นครพนม</option>
              <option>นครราชสีมา</option>
              <option>นครศรีธรรมราช</option>
              <option>นครสวรรค์</option>
              <option>นนทบุรี</option>
              <option>นราธิวาส</option>
              <option>น่าน</option>
              <option>บึงกาฬ</option>
              <option>บุรีรัมย์</option>
              <option>ปทุมธานี</option>
              <option>ประจวบคีรีขันธ์</option>
              <option>ปราจีนบุรี</option>
              <option>ปัตตานี</option>
              <option>พระนครศรีอยุธยา</option>
              <option>พะเยา</option>
              <option>พังงา</option>
              <option>พัทลุง</option>
              <option>พิจิตร</option>
              <option>พิษณุโลก</option>
              <option>เพชรบุรี</option>
              <option>เพชรบูรณ์</option>
              <option>แพร่</option>
              <option>ภูเก็ต</option>
              <option>มหาสารคาม</option>
              <option>มุกดาหาร</option>
              <option>แม่ฮ่องสอน</option>
              <option>ยะลา</option>
              <option>ยโสธร</option>
              <option>ระนอง</option>
              <option>ระยอง</option>
              <option>ราชบุรี</option>
              <option>ร้อยเอ็ด</option>
              <option>ลพบุรี</option>
              <option>ลำปาง</option>
              <option>ลำพูน</option>
              <option>เลย</option>
              <option>ศรีสะเกษ</option>
              <option>สกลนคร</option>
              <option>สงขลา</option>
              <option>สตูล</option>
              <option>สมุทรปราการ</option>
              <option>สมุทรสงคราม</option>
              <option>สมุทรสาคร</option>
              <option>สระบุรี</option>
              <option>สระแก้ว</option>
              <option>สิงห์บุรี</option>
              <option>สุพรรณบุรี</option>
              <option>สุราษฎร์ธานี</option>
              <option>สุรินทร์</option>
              <option>สุโขทัย</option>
              <option>หนองคาย</option>
              <option>หนองบัวลำภู</option>
              <option>อำนาจเจริญ</option>
              <option>อุดรธานี</option>
              <option>อุตรดิตถ์</option>
              <option>อุทัยธานี</option>
              <option>อุบลราชธานี</option>
              <option>อ่างทอง</option>
            </select>
            <span class="invalid-feedback">{{ errors.first('province') }}</span>
          </div>

          <div class="form-group">
            <label>วันเกิด</label>
            <input
              type="text"
              name="birthDate"
              class="form-control"
              v-validate="'required|date_format:dd/MM/yyyy'"
              v-model.trim="form.birthDate"
              v-mask="'##/##/####'"
              placeholder="dd/mm/yyyy (ค.ศ.)"
              :class="{ 'is-invalid': errors.has('birthDate')}"
            />
            <span class="invalid-feedback">{{ errors.first('birthDate') }}</span>
          </div>


          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="tel"
              v-validate="'required|max:10|numeric'"
              v-model.trim="form.tel"
              :class="{ 'is-invalid': errors.has('tel') }"
              placeholder="เบอร์โทรศัพท์"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fas fa-phone"></span>
              </div>
            </div>
            <span class="invalid-feedback">{{ errors.first('tel') }}</span>
          </div>

          <div class="input-group mb-3">
            <input
              type="text"
              class="form-control"
              name="lineId"
              v-model.trim="form.lineId"
              placeholder="ไลน์ไอดี"
            />
            <div class="input-group-append">
              <div class="input-group-text">
                <span class="fab fa-line"></span>
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
             <button type="submit" class="btn bg-gradient-warning btn-block text-white">Register</button>
             <router-link to="/login" class="btn bg-gradient-success btn-block text-white">Login</router-link>
            </div>
            <!-- /.col -->
            <!-- /.col -->
          </div>
        </form>
      </div>
      <!-- /.form-box -->
    </div>
    <!-- /.card -->
  </div>
  <!-- /.register-box -->
</template>

<script>
import Province from "../components/Province";
import axios from "axios";
export default {
  name: "register",
  components: {
    Province
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
        firstName: "",
        lastName: "",
        gender: "",
        province: "",
        birthDate: "",
        tel: "",
        lineId: ""
      },
      errorMessage: ""
    };
  },
  methods: {
    // บันทึกข้อมูลลงทะเบียน
    onSubmit() {
      this.$validator.validateAll().then(valid => {
        if (!valid) return;
        axios
          .post("backend/signup", this.form)
          .then(response => {
            console.log(response.data);
            if(response.data.status == 'S') {
            this.$Progress.start()
            this.$swal.fire("Register Success!", "สมัครสมาชิกเรียบร้อยแล้ว", "success")
            this.$router.push({ name: "login" })
            this.$Progress.finish()
            }
            else {
              this.$Progress.start()
              this.$swal.fire("Register Error!", "สมัครสมาชิกไม่สำเร็จ", "error");
              this.$Progress.fail()
              }
            
          })
          .catch(err => (this.errorMessage = err.response.data.message));
      });
    },

  }
};
</script>

<style scoped>
.text-warning {
  font-size: 60px;
}

.login-box-msg {
  font-size: 20px;
  font-weight: bold;
}

.input-group-text-date {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: center;
  align-items: center;
  padding: 0.375rem 0.75rem;
  margin-bottom: 0;
  font-size: 1rem;
  font-weight: 400;
  line-height: 1.5;
  color: #495057;
  text-align: center;
  white-space: nowrap;
  background-color: #e9ecef;
  border: 1px solid #ced4da;
  border-radius: 0.25rem;
}
</style>
